import { useLocation } from '@reach/router';
import { Link, withPrefix } from 'gatsby';
import React, { useContext } from 'react';
import Context from '../../context/Context';
import useAuthModal from '../../hooks/useAuthModal';
import { LoginButton } from '../buttons';
import { Social } from '../interfaces';
import { AuthLink } from '../links';
import { SocialSection } from '../styled';

const NewHero = () => {
  const { opened, openModal, user, signOut } = useAuthModal();
  const data = useContext(Context);
  const { socialShare } = data;
  const { pathname } = useLocation();
  const virtual = pathname.includes('virtual');

  return (
    <div className="work-hero desktop" id="top">
      <img
        className="fedscoop-logo"
        src="https://sng-client-assets.s3.us-east-1.amazonaws.com/fedscoop/upgather/workday/2025/new+design/FedScoop.svg"
        alt="FedScoop Federal Forum - Hero Lockup"
      />
      <br />
      <h1 style={{ marginLeft: -10 }}>Federal Forum</h1>
      <h2>
        <div className="desktop">
          <span className="no-wrap">AI, Security, and the Rise of</span>
          <br />
          <span className="no-wrap">the Skills-Based Workforce</span>
        </div>
        <div className="mobile">
          <span className="no-wrap">AI, Security, and the Rise of the</span>
          <br />
          <span className="no-wrap">Skills-Based Workforce</span>
        </div>
      </h2>
      <p className='hero-date'>March 13, 2025 | Waldorf Astoria, Washington, D.C.</p>
      <img
        className="sponsored-by-workday"
        src="https://sng-client-assets.s3.us-east-1.amazonaws.com/fedscoop/upgather/workday/2025/new+design/SponsoredBy.svg"
        alt="FedScoop Federal Forum - Hero Lockup"
      />
    </div>
  );
};

export default NewHero;
